var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('img',{attrs:{"src":("./images/" + _vm.imagename + ".webp")}}),_c('div',{staticClass:"bubble"},[_c('span',[_vm._v(_vm._s(_vm.bubbletext))])])])}
var staticRenderFns = []

export { render, staticRenderFns }